import { useCart } from "../../app/context/cart-context/cart-context";
import { Suspense, useEffect, useState } from "react";

import { Spinner } from "../template/spinner/spinner";
import { OrderButton } from "../template/buttons/order-button/order-button";
import { QuantitySelector } from "../template/inputs/quantity-selector/quantity-selector";

import "./cart.css";

export const Cart = () => {

    const { cart} = useCart();

    const [currentTotal, setCurrentTotal] = useState(0);

    useEffect(() => {
        setCurrentTotal(() => {
           return cart.reduce((total, item) => total + parseFloat(item.price) * item.qtt, 0)
        })
    }, [cart])

    const result = cart
        .filter(item => cart.some(cartItem => cartItem.id === item.id))
        .map(product => {

            return (
                <tr  key={product.id}>
                    <td>{product.name}</td>
                    <td><QuantitySelector productId={product.id}/></td>
                    <td className="text-end">{product.price}</td>
                    <td className="text-end">{product.price * product.qtt}</td>
                </tr>
            )
    });

    return (
        <div className="container mb-5">
            {cart.length === 0 ?
                    <div className="h4 mt-3 text-center">Кошик пустий</div>
                :
                    <>
                        <OrderButton/>
                        <Suspense fallback={<Spinner/>}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col" className="">Товар</th>
                                        <th scope="col" className="">Кількість</th>
                                        <th scope="col" className=" text-end">Ціна</th>
                                        <th scope="col" className=" text-end">Cума</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th scope="col" colSpan={3} className="text-end">До сплати</th>
                                        <th scope="col" colSpan={2} className="text-end">{currentTotal.toFixed(2)}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        
                        </Suspense>
                    </>
            }
            
        </div>
    )
    
}
